import type { CandidateProfileData } from '../types/generated'

const API_BASE = ''

export async function getCandidateProfileData(): Promise<CandidateProfileData> {
  const response = await fetch(`${API_BASE}/api/candidate/profile-data`, {
    credentials: 'include',
  })
  if (!response.ok) {
    throw new Error('Failed to load profile data')
  }
  return response.json()
}

export async function updateCandidateProfileData(
  data: CandidateProfileData
): Promise<CandidateProfileData> {
  const response = await fetch(`${API_BASE}/api/candidate/profile-data`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'include',
  })
  if (!response.ok) {
    throw new Error('Failed to update profile data')
  }
  return response.json()
}
